import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import {reaction, autorun} from 'mobx'; // eslint-disable-line no-unused-vars
import Slider from 'react-slick';
import imagePaths from '../../../assets';
import prefetchImages from 'prefetch-image';

@inject ('RootStore')
@observer class CT5Colorizer extends Component {

  constructor(props) {
    super(props);

    //Bindings and click events
    this.ActiveClass = 'isActive';
    this.setActiveTrim = this.setActiveTrim.bind(this);
    this.setActiveColor = this.setActiveColor.bind(this);
    this.toggleDisclaim = this.toggleDisclaim.bind(this);
    this.setActiveInterior = this.setActiveInterior.bind(this);
    this.toggleView = this.toggleView.bind(this);
    this.compriseBYO = this.compriseBYO.bind(this);
    this.showBYO = this.showBYO.bind(this);

    this.state = {
      hideDisclaim : true
    }

    //Set the current trim and subsequent colors available
    this.currentTrim = Object.keys(this.props.RootStore.globalPropsStore.getAvailableTrims)[0];
    this.props.RootStore.globalPropsStore.setCurrentProps('currentTrim', this.currentTrim );
    this.colorsAvailable = this.props.RootStore.globalPropsStore.getAvailableTrims[this.currentTrim].colorsAvailable;
    this.currentInterior = this.props.RootStore.globalPropsStore.getColors[this.colorsAvailable[0]].interiorsAvailable[this.currentTrim][0];
    this.props.RootStore.globalPropsStore.setCurrentProps('currentColor', this.colorsAvailable[0]);
    this.props.RootStore.globalPropsStore.setCurrentProps('currentInterior', this.currentInterior);
    this.props.RootStore.globalPropsStore.setCurrentProps('activeCube', this.colorsAvailable[0]);
    //
    //Preload Assets
    const fileArray = [
        imagePaths.exterior_ct5_v_G7C,
        imagePaths.exterior_ct5_v_G9K,
        imagePaths.exterior_ct5_v_GAZ,
        imagePaths.exterior_ct5_v_GBA,
        imagePaths.exterior_ct5_v_GJ0,
        imagePaths.exterior_ct5_v_GJI,
        imagePaths.exterior_ct5_v_GKK,
        imagePaths.exterior_ct5_v_GRW,
        imagePaths.exterior_ct5_v_GSK,
        imagePaths.interior_ct5_v_H2X,
        imagePaths.interior_ct5_v_HND,
        imagePaths.interior_ct5_v_HXR,
        imagePaths.interior_ct5_v_HZK,
        imagePaths.exterior_luxury_G1W,
        imagePaths.exterior_luxury_G9K,
        imagePaths.exterior_luxury_GAZ,
        imagePaths.exterior_luxury_GBA,
        imagePaths.exterior_luxury_GJ0,
        imagePaths.exterior_luxury_GJI,
        imagePaths.exterior_luxury_GKK,
        imagePaths.exterior_luxury_GLR,
        imagePaths.exterior_luxury_GLU,
        imagePaths.exterior_luxury_GSK,
        imagePaths.interior_luxury_H2G,
        imagePaths.interior_luxury_HIT,
        imagePaths.exterior_premium_luxury_G1W,
        imagePaths.exterior_premium_luxury_G9F,
        imagePaths.exterior_premium_luxury_G9K,
        imagePaths.exterior_premium_luxury_GAZ,
        imagePaths.exterior_premium_luxury_GBA,
        imagePaths.exterior_premium_luxury_GJ0,
        imagePaths.exterior_premium_luxury_GJI,
        imagePaths.exterior_premium_luxury_GKK,
        imagePaths.exterior_premium_luxury_GLR,
        imagePaths.exterior_premium_luxury_GLU,
        imagePaths.exterior_premium_luxury_GSK,
        imagePaths.interior_premium_luxury_H1Y,
        imagePaths.interior_premium_luxury_HAV,
        imagePaths.interior_premium_luxury_HIK,
        imagePaths.interior_premium_luxury_HUN,
        imagePaths.interior_premium_luxury_HZK,
        imagePaths.exterior_sport_G1W,
        imagePaths.exterior_sport_G7C,
        imagePaths.exterior_sport_G9K,
        imagePaths.exterior_sport_GAZ,
        imagePaths.exterior_sport_GBA,
        imagePaths.exterior_sport_GJ0,
        imagePaths.exterior_sport_GJI,
        imagePaths.exterior_sport_GKK,
        imagePaths.exterior_sport_GSK,
        imagePaths.interior_sport_H2X,
        imagePaths.interior_sport_HND,
        imagePaths.interior_sport_HXR,
        imagePaths.interior_sport_HZK
     ];


    const fileArrayClean = [];

    for (var files of fileArray) {
      for(var url of files){
        fileArrayClean.push(url);
      }
    }


    this.props.RootStore.globalPropsStore.setCurrentProps('isLoading', true);
    prefetchImages(fileArrayClean).then(() => {
      this.props.RootStore.globalPropsStore.setCurrentProps('isLoading', false);
    });

  }

  getQueryString = (field, url) => {
  	const href = url ? url : window.location.href;
  	const reg = new RegExp( `[?&]${field}=([^&#]*)`, 'i' );
  	const string = reg.exec(href);
  	return string ? string[1] : null;
  };

  toggleDisclaim = ()=>{
    this.setState({hideDisclaim: !this.state.hideDisclaim});
  }

  renderActiveTrim = (currentTrim)=>{
    const {RootStore} = this.props;
    if(currentTrim === RootStore.globalPropsStore.getCurrentProps.currentTrim){
      return this.ActiveClass;
    }
  }

  compriseBYO = (e)=>{
    const {RootStore} = this.props;
    let qs = this.getQueryString('developMode');
    let isDevelop = (qs === null)? false : qs;
    let byoLinks = RootStore.globalPropsStore.getByoLinks;
    let cturl = byoLinks[RootStore.globalPropsStore.getCurrentProps.currentTrim][RootStore.globalPropsStore.getCurrentProps.currentColor][RootStore.globalPropsStore.getCurrentProps.currentInterior.toUpperCase()];
    if(isDevelop === 'true'){
      window.open(cturl.replace("https://www.cadillac.com", "https://proj-www.cadillac.com"),'_blank');
    }else{
      window.open(cturl,'_blank');
    }
    e.preventDefault();
  }

  showBYO = () => {
    const {RootStore} = this.props;
    let byoLinks = RootStore.globalPropsStore.getByoLinks;
    return byoLinks[RootStore.globalPropsStore.getCurrentProps.currentTrim];
  }

  setActiveTrim = (e) => {
    const {RootStore} = this.props;
    const trim = e.currentTarget.dataset.trim;
    const cc = RootStore.globalPropsStore.getCurrentProps.currentColor;
    const colors = RootStore.globalPropsStore.getColors;
    RootStore.globalPropsStore.setCurrentProps('currentTrim', trim);
    // Disabling reset to exterior on trim select
    // RootStore.globalPropsStore.setCurrentProps('currentView', 'exterior');
    if(this.checkIfActive({exterior:colors[cc].colorSlug}) === 'inActive'){
      this.resetColor();
    }else{
      RootStore.globalPropsStore.setCurrentProps('activeCube', cc);
    }
    this.resetInterior();
    e.preventDefault();
  }

  setActiveColor = (e) => {
    const {RootStore} = this.props;
    const color = e.currentTarget.dataset.color;
    RootStore.globalPropsStore.setCurrentProps('currentColor', color);
    this.resetInterior();
    this.setActiveCube(e);
    e.preventDefault();
  }

  setActiveInterior = (e) => {
    const {RootStore} = this.props;
    const interior = e.currentTarget.dataset.interior;
    this.setActiveCube(e);
    RootStore.globalPropsStore.setCurrentProps('currentInterior', interior);
    e.preventDefault();
  }

  setActiveCube = (e)=> {
    const {RootStore} = this.props;
    const cubeId = (e.currentTarget.hasAttribute("data-color")) ? e.currentTarget.dataset.color : e.currentTarget.dataset.interior
    RootStore.globalPropsStore.setCurrentProps('activeCube', cubeId);
  }

  checkIfActive =(object)=> {
    const {RootStore} = this.props;
    const objectKeys = Object.keys(object);
    const type = objectKeys[0];
    const value = object[type];
    const ct = RootStore.globalPropsStore.getCurrentProps.currentTrim;
    const ca = RootStore.globalPropsStore.getAvailableTrims[ct].colorsAvailable;
    const cc = RootStore.globalPropsStore.getCurrentProps.currentColor;
    const ia = RootStore.globalPropsStore.getColors[cc].interiorsAvailable[ct];

    if(type === 'exterior'){
      if(!ca.includes(value)){
        return 'inActive';
      }else{
        if(value===RootStore.globalPropsStore.getCurrentProps.activeCube){
          return 'isActive';
        }
      }
    }

    if(type === 'interior'){
      if(!ia.includes(value)){
        return 'inActive';
      }else{
        if(value===RootStore.globalPropsStore.getCurrentProps.activeCube){
          return 'isActive';
        }
      }
    }
  }

  flashPreloader = ()=>{
    const {RootStore} = this.props;
    RootStore.globalPropsStore.setCurrentProps('isLoading', true);
    setTimeout(function(){
      RootStore.globalPropsStore.setCurrentProps('isLoading', false);
    },650);
  }

  resetColor = () =>{
    const {RootStore} = this.props;
    const ct = RootStore.globalPropsStore.getCurrentProps.currentTrim;
    const cc = RootStore.globalPropsStore.getAvailableTrims[ct].colorsAvailable[0];
    RootStore.globalPropsStore.setCurrentProps('currentColor', cc);
    RootStore.globalPropsStore.setCurrentProps('activeCube', cc);
    this.setState({hideDisclaim: true});
  }

  resetInterior = () =>{
    const {RootStore} = this.props;
    const cc = RootStore.globalPropsStore.getCurrentProps.currentColor;
    const ct = RootStore.globalPropsStore.getCurrentProps.currentTrim;
    const ia = RootStore.globalPropsStore.getColors[cc].interiorsAvailable[ct];
    RootStore.globalPropsStore.setCurrentProps('currentInterior', ia[0]);
    this.setState({hideDisclaim: true});
  }

  renderTrims = ()=>{
    const {RootStore} = this.props;
    const trims = RootStore.globalPropsStore.getAvailableTrims;
    return (
      <ul className="trim-selection">
        {Object.keys(trims).map(key => (
          <li className={this.renderActiveTrim(trims[key].trimSlug)} key={trims[key].trimSlug}>
            <a href={"#" + trims[key].trimSlug} aria-label={"Trim: " + trims[key].trimSlug} className="stat-tab-link" data-dtm="colorizer" alt={"Trim:" + trims[key].trimSlug} onClick={this.setActiveTrim} data-trim={trims[key].trimSlug} > {trims[key].trimTitle} </a>
          </li>
        ))}
      </ul>
    )
  }

  toggleView =(e)=>{
    const {RootStore} = this.props;
    const view = e.currentTarget.dataset.view;
    RootStore.globalPropsStore.setCurrentProps('currentView', view);
    e.preventDefault();
  }

  renderViewToggle = ()=>{
    const {RootStore} = this.props;
    const currentView = RootStore.globalPropsStore.getCurrentProps.currentView;
    return (
      <ul className="view-selection">
          <li className={currentView === 'exterior' ? 'isActive' : ''}>
            <a href='#ext' onClick={this.toggleView} data-view="exterior" alt='interior' className="stat-tab-link" data-dtm="colorizer">Exterior</a>
          </li>
          <li className={currentView === 'interior' ? 'isActive' : ''}>
            <a href='#int' onClick={this.toggleView} data-view="interior" alt='interior' className="stat-tab-link" data-dtm="colorizer">Interior</a>
          </li>
      </ul>
    )
  }

  renderColors = ()=>{
    const {RootStore} = this.props;
    const colors = RootStore.globalPropsStore.getColors;
    return (
      <ul className="color-blocks">
        {Object.keys(colors).map(key => (
          <React.Fragment key={colors[key].colorSlug}>
            <li className={this.checkIfActive({exterior:colors[key].colorSlug})}>
              <a href={'#' + colors[key].colorSlug} aria-label="select a color" className={'color--' + colors[key].colorSlug + ' stat-image-link'} data-dtm="colorizer" alt="link1" onClick={this.setActiveColor} data-color={colors[key].colorSlug}><span className="visually-hidden">{colors[key].colorTitle}</span></a>
              <span className="tip">

                {this.checkIfActive({exterior:colors[key].colorSlug}) === 'inActive' &&
                  <React.Fragment>
                    Not available with selected trim.
                  </React.Fragment>
                }
                {this.checkIfActive({exterior:colors[key].colorSlug}) !== 'inActive' &&
                  <React.Fragment>
                    {colors[key].colorTitle}
                  </React.Fragment>
                }
              </span>
            </li>
          </React.Fragment>
        ))}
      </ul>
    )
  }

  renderInteriors = ()=>{
    const {RootStore} = this.props;
    const interiors = RootStore.globalPropsStore.getInteriors;

    return (
      <ul className="color-blocks">
        {Object.keys(interiors).map(key => (
          <React.Fragment key={interiors[key].interiorSlug}>
            <li className={this.checkIfActive({interior:interiors[key].interiorID})} style={{backgroundImage: `url(${interiors[key].interiorThumb})`}}>
              <a href={'#' + interiors[key].interiorSlug} aria-label="select an interior option" className="stat-image-link" data-dtm="colorizer" alt="link1" onClick={this.setActiveInterior} data-interior={interiors[key].interiorID}><span className="visually-hidden">{interiors[key].colorTitle}</span></a>
              <span className="tip">

                {this.checkIfActive({interior:interiors[key].interiorID}) === 'inActive' &&
                  <React.Fragment>
                        Not available with selected trim or exterior color.
                  </React.Fragment>
                }

                {this.checkIfActive({interior:interiors[key].interiorID}) !== 'inActive' &&
                  <React.Fragment>
                    {interiors[key].interiorTitle}
                  </React.Fragment>
                }

              </span>
            </li>
          </React.Fragment>
        ))}
      </ul>
    )
  }

  renderSlider =()=>{

    const {RootStore} = this.props;
    const sliderSettings = RootStore.globalPropsStore.getSliderProps;
    const currentView = RootStore.globalPropsStore.getCurrentProps.currentView;
    const currentExterior = RootStore.globalPropsStore.getCurrentProps.currentColor;
    const currentExteriorImages = RootStore.globalPropsStore.colors[currentExterior].exteriorImages[RootStore.globalPropsStore.getCurrentProps.currentTrim];
    const currentInterior = RootStore.globalPropsStore.getCurrentProps.currentInterior;
    const currentInteriorImages = RootStore.globalPropsStore.interiors[currentInterior].interiorImages[RootStore.globalPropsStore.getCurrentProps.currentTrim];

    if(currentView === 'exterior'){
      return (
        <Slider {...sliderSettings}>
          {currentExteriorImages.map((car, index) => (
            <div key={index}>
              <img alt={'image' + index} src={car} width="100%" height="auto" />
            </div>
          ))}
        </Slider>
      )
    }
    if(currentView === 'interior'){
      return (
        <Slider {...sliderSettings}>
          {currentInteriorImages.map((car, index) => (
            <div key={index}>
              <img alt={'image' + index} src={car} width="100%" height="auto" />
            </div>
          ))}
        </Slider>
      )
    }

  }

  showDisclaimer = () => {
    const {RootStore} = this.props;
    const cc = RootStore.globalPropsStore.getCurrentProps.currentColor;
    const ccd = RootStore.globalPropsStore.getColors[cc].disclaimer
    const ci = RootStore.globalPropsStore.getCurrentProps.currentInterior;
    const cid = RootStore.globalPropsStore.getInteriors[ci].disclaimer;
    const isExterior = (RootStore.globalPropsStore.getCurrentProps.currentView === 'exterior')? true : false;
    const hasExtDisclaimer = (RootStore.globalPropsStore.getColors[cc].disclaimer)? true : false;
    const hasIntDisclaimer = (RootStore.globalPropsStore.getInteriors[ci].disclaimer)? true : false;
    if((hasExtDisclaimer && isExterior) || (hasIntDisclaimer && !isExterior)){
      return (
        <div className={this.state.hideDisclaim ? 'disclosure' : 'disclosure isActive'}>
          {isExterior &&
            <React.Fragment>
              {ccd}
            </React.Fragment>
          }
          {!isExterior &&
            <React.Fragment>
              {cid}
            </React.Fragment>
          }
        <button onClick={this.toggleDisclaim}>close</button></div>
      );
    }else{
      return false;
    }
  }

  componentDidMount(){
    let qs = this.getQueryString('developMode');
    let isDevelop = (qs === null)? false : qs;
    if(isDevelop === 'true'){
      alert('Application is in DEVELOPER debug mode. Please see console for details.');
      console.log('Application is in DEVELOPER debug mode. Outbound linkage will now direct to the proj-www.cadillac.com URL.');
      console.log('--------------------------');
      console.log('Additional logging may be present in this mode.');
    }
  }

  render() {

    const {RootStore} = this.props;
    const cc = RootStore.globalPropsStore.getCurrentProps.currentColor;
    const ci = RootStore.globalPropsStore.getCurrentProps.currentInterior;
    const ccTitle = RootStore.globalPropsStore.getColors[cc].colorTitle;
    const ciTitle = RootStore.globalPropsStore.getInteriors[ci].interiorTitle;
    const isExterior = (RootStore.globalPropsStore.getCurrentProps.currentView === 'exterior')? true : false;
    const hasExtDisclaimer = (RootStore.globalPropsStore.getColors[cc].disclaimer)? true : false;
    const hasIntDisclaimer = (RootStore.globalPropsStore.getInteriors[ci].disclaimer)? true : false;
    const showBYO = this.showBYO();

    return (
      <div className="ct5-colorizer">

        { RootStore.globalPropsStore.getCurrentProps.isLoading &&
          <div className="preloader"><div className="loader"></div></div>
        }

        { this.showDisclaimer() }


        <div className={isExterior ? 'row expanded align-center viz-slider viz-slider--exterior align-middle' : 'row expanded align-center align-middle viz-slider viz-slider--interior'}>
          <div className="columns small-12 medium-8">
          { ! RootStore.globalPropsStore.getCurrentProps.isLoading &&
            <React.Fragment>
              {this.renderSlider()}
            </React.Fragment>
          }
          </div>
        </div>
        <div className="row vf-heading">
          <div className="columns text-center">
            {this.renderTrims()}
          </div>
        </div>
        <div className="row vf-heading color-menu-row align-center align-middle">
          <div className="columns">
            <div className="row align-center">
              {isExterior &&
                <div className="columns color-menu small-12 medium-12 text-center">
                  <p className="color-menu__current-color">{ccTitle} <button className="dagger" onClick={this.toggleDisclaim}><sup>{hasExtDisclaimer ? '\u2020' : false}</sup></button></p>
                  { this.renderColors() }
                </div>
              }
              {!isExterior &&
                <div className="columns color-menu small-12 medium-12 text-center">
                  <p className="color-menu__current-color">{ciTitle} <button className="dagger" onClick={this.toggleDisclaim}><sup>{hasIntDisclaimer ? '\u2020' : false}</sup></button></p>
                  { this.renderInteriors() }
                </div>
              }
            </div>
          </div>
        </div>
        <div className="row align-center vf-heading">
          <div className="columns small-12 medium-6 text-center">
            {this.renderViewToggle()}
          </div>
        </div>
        {/*{  showBYO &&
          <div className="row cta vf-heading bap-row">
            <div className="columns text-center">
              <a href="#value" onClick={this.compriseBYO} aria-label="select a color" alt="link" className="btn bap-button stat-button-link" data-dtm="colorizer">Build and Price</a>
            </div>
          </div>
        }*/}
        </div>
    );
  }
}

export default CT5Colorizer;
